import { InjectionToken } from '@angular/core';
import { AuthConfig } from './interface';

export const OAUTH_CONFIG = new InjectionToken<AuthConfig>('app.oauth.config');
export const APP_PERMISSIONS = new InjectionToken<string[]>('app.permissions');
export const APP_ADMIN_PERMISSIONS = new InjectionToken<string[]>(
  'app.admin.permissions'
);
